<template>
    <div id="app">
        <!-- 一時的なチュートリアル削除に伴いコメントアウト(20230904) -->
        <!-- <TopBar class="slideable-top" ref="topBar" v-on:click-share="clickShare" v-on:display-tutorial="dialog = true" /> -->
        <TopBar class="slideable-top" ref="topBar" v-on:click-share="clickShare" />
        <!-- サイドバーメニュー -->
        <div class="sidebar" :class="{ 'sidebar-open': open, 'sidebar-close': !open }">
            <p class="sidebar-contents">グラフ一覧</p>
            <!-- カテゴリ機能。リリース段階でカテゴリ分けされてないのでコメントアウト。将来復活させます。 -->
            <!-- <v-col class="d-flex" cols="12" sm="10">
                <v-select :items="categoryiItems" label="表示カテゴリ" solo hide-details v-model="selectedCategory"></v-select>
            </v-col> -->
            <div v-for="graphItem in filteredGraphListByCategory" :key="graphItem.graphType" :id="graphItem.graphType"
                class="template-item" style="
             {
              background: white;
            }
        ">
                <GraphListTemplate class="side-graph purple lighten-5" :class="graphItem.categoryId"
                    :graphTitle="graphItem.graphName" :graphDescription="graphItem.graphDescription"
                    :imageUrl="graphItem.graphImage" @addGraphFunction="addLayoutbySide(graphItem.graphType)" />
            </div>
        </div>
        <!-- ダッシュボード+フィルター -->
        <div class="dashboard" scrollable id="dashboard" :class="{ 'sidebar-open': open, 'sidebar-close': !open }"
            :style="dashBoardStyles">
            <div class="main" ref="main" v-scroll:#dashboard="handleScroll" :class="{
                'sidebar-open-dashboard': open,
                'sidebar-close-dashboard': !open,
            }">
                <FilterParts ref="filterParts" v-if="!open" />
                <!-- ダッシュボード -->
                <grid-layout ref="gridLayout" :layout.sync="editingDashBoard.dashBoardLayout" :col-num="colNum"
                    :row-height="rowHeight" :is-draggable="true" :is-resizable="true" :is-mirrored="false"
                    :vertical-compact="false" :margin="colMargin" :use-css-transforms="true" :isDraggable="open"
                    :isResizable="open">
                    <grid-item class="item" v-for="item in editingDashBoard.dashBoardLayout" :isDraggable="open"
                        :isResizable="open" :x="item.x" :y="item.y" :w="item.w" :h="item.h" :i="item.i" :key="item.i"
                        :style="{
                            outline: item.isTemplate ? '2px dashed darkmagenta' : '',
                        }" @click="editorShow = true">
                        <DashBoardContentLayoutTemplate :w="item.w" :h="item.h" :graphTitle="item.graphTitle"
                            :graphType="item.graphType" :graphDescription="item.graphDescription" :index="item.i"
                            :open="open" @close="deleteItem" @changeGraphTitle="changeGraphTitle"
                            @changeGraphDescription="changeGraphDescription" />
                    </grid-item>
                </grid-layout>
                <!-- ダッシュボード共有のモーダル -->
                <v-dialog v-model="shareDialog" :width="width">
                    <v-card>
                        <v-card-title primary-title class="headline grey lighten-2">
                            ダッシュボード共有
                            <v-spacer></v-spacer>
                            <v-btn icon @click="shareDialog = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-card-title>
                        <v-card-subtitle class="grey lighten-2">
                            共有先の社員を選択してください。
                            <v-spacer></v-spacer>
                        </v-card-subtitle>
                        <v-container>
                            <div>共有するダッシュボード：{{ displayDashBoardName }}</div>
                        </v-container>
                        <v-container>
                            <v-text-field v-model="search" append-icon="mdi-magnify" label="検索" single-line
                                color="purple darken-2"></v-text-field>
                        </v-container>
                        <v-data-table v-model="selected" :headers="headers" :items="desserts" :single-select="singleSelect"
                            item-key="userId" show-select class="elevation-1" :search="search"></v-data-table>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn dark color="#7E6990" rounded @click="shareConfirmDialog = true">確認</v-btn>
                        </v-card-actions>
                        <v-dialog v-model="shareConfirmDialog" :width="width">
                            <v-card>
                                <v-card-title primary-title>以下の社員に共有します。よろしいですか？</v-card-title>
                                <v-list>
                                    <v-data-table :headers="headers" :items="selected" item-key="userId" class="elevation-1"
                                        hide-default-footer></v-data-table>
                                </v-list>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn dark color="#7E6990" rounded @click="shareConfirmDialog = false">戻る</v-btn>
                                    <v-btn color="#7E6990" rounded outlined @click="dashboardShare">共有</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-card>
                </v-dialog>
                <!-- 一時的なチュートリアル削除に伴いコメントアウト(20230904) -->
                <!-- チュートリアル動画のモーダル -->
                <!-- <v-dialog v-model="dialog" :width="width">
                    <v-card>
                        <v-card-title class="headline grey lighten-2" primary-title>
                            チュートリアル
                            <v-spacer></v-spacer>
                            <v-btn icon @click="dialog = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-card-title>

                        <v-card-text class="v-card-tutorial">
                            <vue-plyr>
                                <video>
                                    <source src="https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-576p.mp4"
                                        type="video/mp4" />
                                </video>
                            </vue-plyr>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-checkbox v-model="nextMovieCheck" label="次回以降表示しない場合はチェックを入れてください。" color="#7E6990"
                                @change="chengeNotShowTutorialFlg"></v-checkbox>
                            <v-spacer></v-spacer>
                            <v-btn color="#7E6990" rounded dark @click="dialog = false">閉じる</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog> -->
            </div>
        </div>
    </div>
</template>

<script>
import interact from "interactjs";
import FilterParts from "../parts/FilterParts";
import VueGridLayout from "vue-grid-layout";
import TopBar from "../layouts/TopBar";
import { eventBus } from "../../main";
import GraphListTemplate from "../layouts/SideMenu/SideMenuGraphListTemplate";
import DashBoardContentLayoutTemplate from "../layouts/DashBoard/DashBoardContentLayoutTemplate";
import GraphList from "../parts/GraphList";
const uuidv4 = require("uuid/v4");
export default {
    name: "app",
    components: {
        GridLayout: VueGridLayout.GridLayout,
        GridItem: VueGridLayout.GridItem,
        TopBar,
        GraphListTemplate,
        DashBoardContentLayoutTemplate,
        FilterParts,
    },
    data() {
        return {
            // ------------------------ //
            rowHeight: 150,
            colNum: 12,
            colMargin: [10, 10],
            defaultGridW: 2,
            defaultGridH: 2,
            maxRows: Infinity,
            mainLeft: 300,
            mainTop: 64,
            // ------------------------ //
            layout: [],
            editingDashBoard: {},
            editingDashBoardIndex: 0,
            egitFlg: false,
            // ------------------------ //
            categoryiItems: [],
            selectedCategory: "",
            // ------------------------ //
            dashboardScrollX: 0,
            dashboardScrollY: 0,
            windowWidth: window.innerWidth,
            WindowHeight: window.innerHeight,
            // ------------------------ //
            search: "",
            shareDialog: false,
            shareConfirmDialog: false,
            dialog: false,
            width: (window.innerWidth * 3) / 5,
            nextMovieCheck: true,
            singleSelect: false,
            selected: [],
            headers: [
                {
                    text: "ユーザID",
                    align: "start",
                    value: "userId",
                },
                { text: "氏名", value: "userName" },
                { text: "役職", value: "positionName" },
                { text: "部門", value: "departmentName" },
            ],
            // マスタ情報のmock、念のためコメントで残す
            // desserts: [
            //   {
            //     userId: "user01",
            //     userName: "開発太郎",
            //     positionName: "一般職",
            //     departmentCode: "システム開発部",
            //   },
            //   {
            //     userId: "user02",
            //     userName: "開発次郎",
            //     positionName: "一般職",
            //     departmentCode: "システム開発部",
            //   },
            //   {
            //     userId: "user03",
            //     userName: "開発三郎",
            //     positionName: "一般職",
            //     departmentCode: "システム開発部",
            //   },
            //   {
            //     userId: "user04",
            //     userName: "開発四郎",
            //     positionName: "一般職",
            //     departmentCode: "システム開発部",
            //   },
            //   {
            //     userId: "user05",
            //     userName: "開発五郎",
            //     positionName: "一般職",
            //     departmentCode: "システム開発部",
            //   },
            //   {
            //     userId: "user06",
            //     userName: "開発六郎",
            //     positionName: "一般職",
            //     departmentCode: "システム開発部",
            //   },
            //   {
            //     userId: "user07",
            //     userName: "開発七郎",
            //     positionName: "一般職",
            //     departmentCode: "システム開発部",
            //   },
            //   {
            //     userId: "user08",
            //     userName: "開発八郎",
            //     positionName: "一般職",
            //     departmentCode: "システム開発部",
            //   },
            //   {
            //     userId: "user09",
            //     userName: "開発九郎",
            //     positionName: "一般職",
            //     departmentCode: "システム開発部",
            //   },
            //   {
            //     userId: "user10",
            //     userName: "開発十郎",
            //     positionName: "一般職",
            //     departmentCode: "システム開発部",
            //   },
            // ],
        };
    },
    computed: {
        //マスタ情報
        desserts() {
            const data = this.$store.getters["domain/masterInfo"];
            // キーをキャメルケースに変換
            const camelData = data.map((e) => { return { userId: e.user_id, userName: e.user_name, positionName: e.position_name, departmentName: e.department_name } })
            return camelData
        },
        // カテゴリリスト
        categoryList() {
            return this.$store.getters["common/categoryList"];
        },
        // カテゴリのグラフリスト
        graphList() {
            return this.$store.getters["common/graphList"];
        },
        // 画面読み込み時に最初に表示されるカテゴリのID
        firstSelectedCategory() {
            return this.$store.getters["common/firstSelectedCategory"];
        },
        // サイドメニューがあいてるかどうか
        open() {
            return this.$store.getters["topBar/open"];
        },
        // 選択中のダッシュボードのID
        selectedDashBoard: {
            get() {
                return this.$store.getters["individual/selectedDashBoard"];
            },
            set(editingDashBoard) {
                this.$store.dispatch(
                    "individual/SET_SELECTED_DASHBOARD",
                    editingDashBoard
                );
            },
        },
        displayDashBoardName() {
            const dashBoardId = this.selectDashBoard.dashBoardId;
            const dashBoards = this.$store.getters["individual/dashBoards"];
            let dashBoardName = "";
            for (let i = 0; i < dashBoards.length; i++) {
                if (dashBoardId == dashBoards[i].dashBoardId) {
                    dashBoardName = dashBoards[i].dashBoardName;
                    return dashBoardName;
                }
            }
            return dashBoardName;
        },
        selectDashBoard() {
            const dashBoardId = this.$store.getters["individual/selectedDashBoard"];
            const dashBoards = this.$store.getters["individual/dashBoards"];
            for (let i = 0; i < dashBoards.length; i++) {
                if (dashBoardId == dashBoards[i].dashBoardId) {
                    return dashBoards[i];
                }
            }
            return "";
        },
        // ユーザごとののダッシュボード情報
        dashBoards: {
            get() {
                return this.$store.getters["individual/dashBoards"];
            },
            set(editingDashBoard) {
                this.$store.dispatch("individual/SET_DASHBOARD", {
                    editingDashBoard: editingDashBoard,
                    operation: "watchDashBords",
                });
            },
        },
        // 共通のグラフリストをカテゴリでソートしたリスト
        filteredGraphListByCategory: function () {
            if (this.selectedCategory === "all") {
                return this.graphList;
            }
            var filteredGraphListByCategory = [];
            for (let graphItem of this.graphList) {
                if (graphItem.categoryId === this.selectedCategory) {
                    filteredGraphListByCategory.push(graphItem);
                }
            }
            return filteredGraphListByCategory;
        },
        // ダッシュボード描画部分のStyle
        dashBoardStyles() {
            var dashboardWidth = this.windowWidth;
            var dashboardHeight = this.WindowHeight - this.mainTop;
            if (this.open) {
                dashboardWidth = this.windowWidth - this.mainLeft;
            }
            return {
                height: `${dashboardHeight}px`,
                width: `${dashboardWidth}px`,
            };
        },
    },
    watch: {
        selectedDashBoard(val) {
            if (val) {
                this.changeDisplayDashboard();
            }
        },
        open(val) {
            if (val) {
                this.setButtonEvent();
            }
        },
        dashBoards(val) {
            if (val) {
                this.changeDisplayDashboard();
            }
        },
    },
    created() {
        // 画面上のカテゴリのプルダウンに表示させる用に配列定義
        for (var i = 0; i < this.categoryList.length; i++) {
            var pushObj = {
                text: this.categoryList[i].categoryName,
                value: this.categoryList[i].categoryId,
            };
            this.categoryiItems.push(pushObj);
        }
        this.selectedCategory = this.firstSelectedCategory;
        // ダッシュボード変更
        this.changeDisplayDashboard();
        this.editingDashBoard = JSON.parse(
            JSON.stringify(this.dashBoards[this.editingDashBoardIndex])
        );
        this.getMasterInfo();
        this.getOwnInfoAndShowTutorial();
    },
    mounted() {
        this.setButtonEvent();

        let entered = false; // サイドバーからドラッグした要素が、右侧のドロップエリアに到達しているかどうか
        let { x: mainDX, y: mainDY } = { x: this.mainLeft, y: this.mainTop };
        let copy = null;
        let movingGridDeltaY = 0;
        let _this = this;
        let x = 0;
        let y = 0;
        let position = { x: 0, y: 0 };
        let scrollX = this.dashboardScrollX;
        let scrollY = this.dashboardScrollY;

        interact(".template-item").draggable({
            inertia: true,
            listeners: {
                start(event) {
                    copy = event.target.cloneNode(true);
                    event.target.appendChild(copy);
                    movingGridDeltaY = event.target.getBoundingClientRect().y;
                    position = { x: _this.dashboardScrollX, y: _this.dashboardScrollY };
                },
                move(event) {
                    position.x += event.dx;
                    position.y += event.dy;
                    copy.style.transform = `translate(${position.x}px, ${position.y}px)`;
                    copy.style.outline = "1px dashed darkmagenta";
                    copy.style.zIndex = "300";
                    // スクロール時ドラッグでグラフ追加したときにに位置がずれるのでサイドバー要素では非表示
                    copy.style.display = "none";
                    let { x: _x, y: _y } = _this.calcXY(
                        position.y + movingGridDeltaY - mainDY,
                        position.x - mainDX
                    );

                    x = _x;
                    y = _y;

                    if (entered) {
                        let currentDragGridData =
                            _this.editingDashBoard.dashBoardLayout[
                            _this.editingDashBoard.dashBoardLayout.length - 1
                            ];
                        if (scrollY != _this.dashboardScrollY) {
                            var scrollYDifference = _this.dashboardScrollY - scrollY;

                            position.y += scrollYDifference;
                            scrollY = _this.dashboardScrollY;
                            currentDragGridData.y = y;
                        } else {
                            currentDragGridData.y = y;
                        }
                        if (scrollX != _this.dashboardScrollX) {
                            scrollX = _this.dashboardScrollX;
                            currentDragGridData.x = x + Math.floor((scrollX + 10) / 160);
                        } else {
                            currentDragGridData.x = x;
                        }
                    }
                },
                end(event) {
                    event.target.removeChild(copy);
                    copy = null;
                    movingGridDeltaY = 0;
                    position = { x: 0, y: 0 };
                    x = scrollX;
                    y = scrollY;
                },
            },
        });

        interact(".main").dropzone({
            accept: ".template-item",
            ondropactivate(event) {
                event.target.classList.add("drop-active");
            },
            ondragenter(event) {
                scrollY = _this.dashboardScrollY;
                entered = true;
                var graphType = event.relatedTarget.id;
                _this.editingDashBoard.dashBoardLayout.push(
                    _this.pushGraphLayout(graphType, { x: -2, y: -2 }, true)
                );
            },
            ondragleave() {
                entered = false;
                _this.editingDashBoard.dashBoardLayout.splice(
                    _this.editingDashBoard.dashBoardLayout.length - 1,
                    1
                );
            },
            ondrop() {
                entered = false;
                _this.editingDashBoard.dashBoardLayout[
                    _this.editingDashBoard.dashBoardLayout.length - 1
                ].isTemplate = false;
            },
            ondropdeactivate(event) {
                event.target.classList.remove("drop-active");
            },
        });
        window.addEventListener("resize", this.handleResize);
    },
    beforeDestroy: function () {
        window.removeEventListener("resize", this.handleResize);
    },

    methods: {
        setTest: function (msg) {
            alert(msg);
        },
        // 一時的なチュートリアル削除に伴いコメントアウト(20230904)
        // showTutorial: function () {
        //     const individualData = this.$store.getters["individual/indivisualInfo"];
        //     this.nextMovieCheck = individualData.not_show_tutorial;
        //     this.dialog = !individualData.not_show_tutorial;
        // },
        chengeNotShowTutorialFlg() {
            // 一時的なチュートリアル削除に伴いコメントアウト(20230904)
            // this.$store.dispatch("individual/SWITCH_NOT_SHOW_TUTORIAL");
            this.$refs.topBar.upsertOwnInfo();
        },
        getMasterInfo() {
            this.$store.dispatch("domain/GET_MASTER_INFO");
        },
        getOwnInfo() {
            this.$store.dispatch("individual/GET_OWN_INFO");
        },
        async getOwnInfoAndShowTutorial() {
            await this.$store.dispatch("individual/GET_OWN_INFO");
            // 一時的なチュートリアル削除に伴いコメントアウト(20230904)
            // this.showTutorial();
        },
        clickShare() {
            this.shareDialog = true;
        },
        dashboardShare() {
            if (this.selected == 0) {
                alert("社員を1人以上選択してください。");
                return;
            }
            const request = {
                users: this.selected,
                dashBoards: [this.selectDashBoard],
            };
            this.$http
                .post("/dashboards/share", request, {
                    headers: {
                        "X-CSRF-TOKEN": this.$cookies.get("csrf_access_token"),
                    },
                })
                .then((res) => {
                    alert("ダッシュボードを共有しました。");
                    this.shareConfirmDialog = false;
                    this.shareDialog = false;
                })
                .catch((error) => {
                    // eslint-disable-next-line no-console
                    console.log(error);
                    alert("ダッシュボードの共有に失敗しました。");
                });
        },
        calcXY(top, left) {
            const colWidth = this.calcColWidth();
            let x = Math.round(
                (left - this.colMargin[0]) / (colWidth + this.colMargin[0])
            );
            let y = Math.round(
                (top - this.colMargin[1]) / (this.rowHeight + this.colMargin[1])
            );
            // Capping
            x = Math.max(Math.min(x, this.colNum - this.defaultGridW), 0);
            y = Math.max(Math.min(y, this.maxRows - this.defaultGridH), 0);
            return { x, y };
        },
        calcColWidth() {
            const placeholderGrid = this.$refs["gridLayout"].$children[0];
            return (
                (placeholderGrid.containerWidth -
                    this.colMargin[0] * (this.colNum + 1)) /
                this.colNum
            );
        },
        // 選択中のダッシュボードが変わったとき
        changeDisplayDashboard: function () {
            for (var i = 0; i < this.dashBoards.length; i++) {
                if (this.dashBoards[i].dashBoardId === this.selectedDashBoard) {
                    this.editingDashBoardIndex = i;
                    break;
                }
            }
            this.editingDashBoard = JSON.parse(
                JSON.stringify(this.dashBoards[this.editingDashBoardIndex])
            );
        },
        // 新規作成ボタン押されたとき
        createDashBoard: function () {
            this.editingDashBoard.dashBoardId = uuidv4();
            this.editingDashBoard = {
                dashBoardId: uuidv4(),
                dashBoardName: "",
                dashBoardOrder: "",
                dashBoardLayout: [],
            };
            this.egitFlg = false;
            // サイドメニュー閉じる
            this.$store.dispatch("topBar/toggleBar");
        },
        // 編集ボタン押されたとき
        editDashBoard: function () {
            this.editingDashBoard = JSON.parse(
                JSON.stringify(this.dashBoards[this.editingDashBoardIndex])
            );
            this.egitFlg = true;
            // サイドメニュー閉じる
            this.$store.dispatch("topBar/toggleBar");
        },
        // ダウンロードボタンが押されたとき
        downloadDashBoard: function () { },
        // 保存ボタンが押されたとき
        saveDashBoard: function () {
            this.$store.dispatch("individual/SET_DASHBOARD", {
                editingDashBoard: this.editingDashBoard,
                operation: "saveDashBoard",
            });
            // サイドメニュー閉じる
            this.$store.dispatch("topBar/toggleBar");
        },
        // キャンセルボタンが押されたとき
        cancelDashBoard: function () {
            this.editingDashBoard = JSON.parse(
                JSON.stringify(this.dashBoards[this.editingDashBoardIndex])
            );
            // サイドメニュー閉じる
            this.$store.dispatch("topBar/toggleBar");
        },
        // 削除ボタンが押されたとき
        deleteDashBoard: function () {
            this.$store.dispatch("individual/SET_DASHBOARD", {
                editingDashBoard: this.editingDashBoard,
                operation: "deleteDashBoard",
            });
            // サイドメニュー閉じる
            this.$store.dispatch("topBar/toggleBar");
        },
        addLayoutbySide: function (graphType) {
            this.addLayout(graphType, { x: 0, y: this.calculateAddLayoutY() }, false);
        },
        // グラフ追加
        addLayout: function (graphType, addXY, isTemplate) {
            this.editingDashBoard.dashBoardLayout.push(
                this.pushGraphLayout(graphType, addXY, isTemplate)
            );
            // TODO 追加したグラフのとこまでスクロールnpm
        },
        pushGraphLayout: function (graphType, addXY, isTemplate) {
            var addGraph = GraphList.filter((e) => { return e.graphType == graphType })[0]
            var layoutUuid = uuidv4();
            var pushGraph = {};

            // グラフ一覧(../parts/GraphList)から情報を取得
            pushGraph = {
                x: addXY.x,
                y: addXY.y,
                w: addGraph.defaultWidth,
                h: addGraph.defaultHeight,
                i: layoutUuid,
                isTemplate: isTemplate,
                graphType: addGraph.graphType,
                graphTitle: addGraph.graphTitle,
                graphDescription: addGraph.graphDescription,
            };

            // if (graphType === "documentFrequency") {
            //   pushGraph = {
            //     x: addXY.x,
            //     y: addXY.y,
            //     w: 2,
            //     h: 2,
            //     i: layoutUuid,
            //     isTemplate: isTemplate,
            //     graphType: "documentFrequency",
            //     graphTitle: "書類の利用頻度タイトル",
            //     graphDescription: "書類の利用頻度説明",
            //   };
            // } else if (graphType === "approvalDocumentTimeAverage") {
            //   pushGraph = {
            //     x: addXY.x,
            //     y: addXY.y,
            //     w: 3,
            //     h: 3,
            //     i: layoutUuid,
            //     isTemplate: isTemplate,
            //     graphType: "approvalDocumentTimeAverage",
            //     graphTitle: "書類別承認時間のタイトル",
            //     graphDescription: "書類別承認時間の説明",
            //   };
            // } else if (graphType === "approvalTimeAverage") {
            //   pushGraph = {
            //     x: addXY.x,
            //     y: addXY.y,
            //     w: 3,
            //     h: 3,
            //     i: layoutUuid,
            //     isTemplate: isTemplate,
            //     graphType: "approvalTimeAverage",
            //     graphTitle: "承認時間のタイトル",
            //     graphDescription: "承認時間の説明",
            //   };
            // } else if (graphType === "documentRejectionRate") {
            //   pushGraph = {
            //     x: addXY.x,
            //     y: addXY.y,
            //     w: 3,
            //     h: 3,
            //     i: layoutUuid,
            //     isTemplate: isTemplate,
            //     graphType: "documentRejectionRate",
            //     graphTitle: "書類別却下率のタイトル",
            //     graphDescription: "書類別却下率の説明",
            //   };
            // } else if (graphType === "userRejectionRate") {
            //   pushGraph = {
            //     x: addXY.x,
            //     y: addXY.y,
            //     w: 3,
            //     h: 3,
            //     i: layoutUuid,
            //     isTemplate: isTemplate,
            //     graphType: "userRejectionRate",
            //     graphTitle: "却下率のタイトル",
            //     graphDescription: "却下率の説明",
            //   };
            // } else if (graphType === "deviceFrequency") {
            //   pushGraph = {
            //     x: addXY.x,
            //     y: addXY.y,
            //     w: 2,
            //     h: 2,
            //     i: layoutUuid,
            //     isTemplate: isTemplate,
            //     graphType: "deviceFrequency",
            //     graphTitle: "デバイスの利用頻度タイトル",
            //     graphDescription: "デバイスの利用頻度説明",
            //   };
            // } else if (graphType === "applyDocumentNumber") {
            //   pushGraph = {
            //     x: addXY.x,
            //     y: addXY.y,
            //     w: 2,
            //     h: 2,
            //     i: layoutUuid,
            //     isTemplate: isTemplate,
            //     graphType: "applyDocumentNumber",
            //     graphTitle: "申請データの総数のタイトル",
            //     graphDescription: "申請データの総数の説明",
            //   };
            // } else {
            //   pushGraph = {
            //     x: addXY.x,
            //     y: addXY.y,
            //     w: 2,
            //     h: 2,
            //     i: layoutUuid,
            //     isTemplate: isTemplate,
            //     graphType: "",
            //     graphTitle: "サンプルのグラフタイトル",
            //     graphDescription: "サンプルのグラフ説明",
            //   };
            // }
            return pushGraph;
        },
        // 追加ボタンを押したときに追加するグラフのy(vue-grid-layout単位)を求める
        calculateAddLayoutY: function () {
            let maxY = 0;
            if (this.editingDashBoard.dashBoardLayout.length == 0) {
                return maxY;
            }
            for (let i in this.editingDashBoard.dashBoardLayout) {
                let editingMaxY = this.editingDashBoard.dashBoardLayout[i].y;
                if (maxY < editingMaxY) {
                    maxY = this.editingDashBoard.dashBoardLayout[i].y;
                }
            }
            return maxY + 1;
        },
        // ダッシュボードの名前が変わったとき
        changeDashBoardName: function (newDashBoardName) {
            this.editingDashBoard.dashBoardName = newDashBoardName;
        },
        // グラフの削除ボタンが押されたとき
        deleteItem: function (el) {
            var index = el.index;
            for (var i = 0; i < this.editingDashBoard.dashBoardLayout.length; i++) {
                if (this.editingDashBoard.dashBoardLayout[i].i === index.toString()) {
                    this.editingDashBoard.dashBoardLayout.splice(i, 1);
                    break;
                }
            }
        },
        changeGraphTitle: function (el) {
            var index = el.index;
            var title = el.title;
            for (var i = 0; i < this.editingDashBoard.dashBoardLayout.length; i++) {
                if (this.editingDashBoard.dashBoardLayout[i].i === index.toString()) {
                    this.editingDashBoard.dashBoardLayout[i].graphTitle = title;
                    break;
                }
            }
        },
        changeGraphDescription: function (el) {
            var index = el.index;
            var description = el.description;
            for (var i = 0; i < this.editingDashBoard.dashBoardLayout.length; i++) {
                if (this.editingDashBoard.dashBoardLayout[i].i === index.toString()) {
                    this.editingDashBoard.dashBoardLayout[i].graphDescription =
                        description;
                    break;
                }
            }
        },
        handleResize: function () {
            // resizeのたびにこいつが発火するので、ここでやりたいことをやる
            this.windowWidth = window.innerWidth;
            this.WindowHeight = window.innerHeight;
        },
        //ダッシュボードの部分をスクロールするごとにこれが作動
        handleScroll(e) {
            this.dashboardScrollX = e.target.scrollLeft;
            this.dashboardScrollY = e.target.scrollTop;
        },
        // イベントバスからのイベントキャッチのため
        setButtonEvent: function () {
            if (this.open) {
                // 残ってると複数回実行されるようになるから1回クリア
                // top
                eventBus.$off("saveDashBoard");
                eventBus.$on("saveDashBoard", this.saveDashBoard);
                eventBus.$off("cancelDashBoard");
                eventBus.$on("cancelDashBoard", this.cancelDashBoard);
                eventBus.$off("deleteDashBoard");
                eventBus.$on("deleteDashBoard", this.deleteDashBoard);

                //side
                eventBus.$off("addLayout");
                eventBus.$on("addLayout", this.addLayout);
            } else {
                // 残ってると複数回実行されるようになるから1回クリア
                eventBus.$off("createDashBoard");
                eventBus.$on("createDashBoard", this.createDashBoard);
                eventBus.$off("editDashBoard");
                eventBus.$on("editDashBoard", this.editDashBoard);
                eventBus.$off("downloadDashBoard");
                eventBus.$on("downloadDashBoard", this.downloadDashBoard);
                eventBus.$off("changeDashBoardName");
                eventBus.$on("changeDashBoardName", this.changeDashBoardName);
            }
        },
        callCreateFilter() {
            return this.$refs.filterParts.createFilter();
        }
    },
};
</script>

<style scoped>
.app-name {
    font-size: larger;
}

.v-card-tutorial {
    padding: 10px 24px 20px !important;
}

.vue-grid-item {
    background: white;
    opacity: 0.9;
    border: 3px solid #d6d1db;
}

.sidebar {
    background-color: #b9b0c0;
    top: 64px;
    /* TopBarの高さ */
    height: 100%;
    /* サイドバーの高さ */
    width: 300px;
    /* サイドバーのwidthを指定 */
    max-width: 300px;
    /* widthの最大値 */
    opacity: 0.9.5;
    /* 透過する 0に近くほど透過する */
    position: fixed;
    /* 左上に要素を固定する(スクロールしても位置は固定される) */
    overflow-x: hidden;
    /* 横軸ではみ出た要素を非表示にする */
    box-sizing: border-box;
    /* paddingとborderを、widthとheightに含める */
    padding: 20px;
    /* サイドバー内のリンクの位置を右にずらす */
    touch-action: none;
    user-select: none;
    z-index: 100;
}

.dashboard {
    position: relative;
    width: 100%;
    max-height: 100%;
    top: 64px;
    /* TopBarの高さ */
    left: 300px;
    /* サイドバーのwidthを指定 */
    overflow: auto;
}

.main {
    background-color: #f6f7fa;
    width: 1930px;
}

.main.drop-active {
    border: 2px dashed skyblue;
}

.item {
    user-select: none;
}

.template-item {
    touch-action: none;
    user-select: none;
    height: 180px;
    margin-bottom: 20px;
}

.editor {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 200px;
    border: 1px solid darkmagenta;
}

.drop-active /deep/ .vue-grid-item.vue-grid-placeholder {
    display: none;
}

.side-graph {
    position: absolute;
    z-index: 200;
    width: 260px;
    height: 180px;
    background: #efedf1;
}

.sidebar-open {
    transform: translateX(0);
    transition: all 0.3s;
}

.sidebar-close {
    transform: translateX(-300px);
    transition: all 0.3s;
}

.slideable-top {
    z-index: 200;
}

.sidebar-open-dashboard {
    background-image: url("../../assets/background.png");
    background-repeat: repeat;
}

.sidebar-close-dashboard {
    background-image: none;
}
</style>
